<script setup>
import HomePage from '@/components/HomePage.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <HomePage />
  </Suspense>
  <ToastHost />
</template>
